module.exports = __webpack_public_path__ + "img/5.cd13a750.jpg";